/* eslint-disable no-restricted-globals */
import { clearAuthLocalStorage } from "helper/logout-helper"
import { UseAuth } from "hook/auth-hook"
import { useEffect } from "react"

/**
 * Rota dedicada para encerrar sessão (ex.: iframe do sistema hospedeiro navegando para /logout).
 */
export function LogoutRoute() {
    const { updateIsLoggedIn } = UseAuth()

    useEffect(() => {
        clearAuthLocalStorage()
        updateIsLoggedIn(false)
        location.replace("/")
    }, [updateIsLoggedIn])

    return null
}
